"use client";

// delegate-shell-theme
// React bindings for the shell theme store. Spec: docs/delegate/THEME.md.
import { useSyncExternalStore } from "react";
import { getShellMode, isShellThemed, subscribe } from "./theme-bridge";

/** True while the Delegate V2 shell is theming this (framed) Meet instance. */
export function useIsShellThemed(): boolean {
  return useSyncExternalStore(subscribe, isShellThemed, () => false);
}

/** DelegateProject's name for the same hook. */
export const useShellThemed = useIsShellThemed;

/** The shell's light/dark mode while shell-themed, otherwise `null`. */
export function useShellMode() {
  return useSyncExternalStore(subscribe, getShellMode, () => null);
}
